module.exports = __webpack_public_path__ + "media/app/assets/notification-instructions-2ae9066d97aaf139144eaea782d0d90e.png";